import { render, staticRenderFns } from "./CompletedOrdersCard.vue?vue&type=template&id=66c22a28&scoped=true"
import script from "./CompletedOrdersCard.vue?vue&type=script&lang=ts"
export * from "./CompletedOrdersCard.vue?vue&type=script&lang=ts"
import style0 from "./CompletedOrdersCard.vue?vue&type=style&index=0&id=66c22a28&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c22a28",
  null
  
)

export default component.exports